// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Jk_kb","iconButton":"styles_iconButton__wpmez","text":"styles_text__IBv8_"};